import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

// Domande e conferme dentro la pagina al posto di window.prompt/confirm (23/10/2026: su Firefox,
// dopo "non permettere altre finestre", prompt/confirm non compaiono più e i bottoni sembrano morti).
// Uso: await conferma('Eliminare…?') → true/false · await avvisa('Errore') · await chiedi('Nome:', 'valore') → testo o null.
// Serve <DialogoHost /> montato nella pagina.
let apri = null;
const coda = (d) => new Promise(ok => { if (!apri) { ok(d.input ? null : false); return; } apri({ ...d, ok }); });
export const conferma = (testo, { si = 'Conferma', pericolo = false } = {}) => coda({ testo, si, pericolo });
export const avvisa = (testo) => coda({ testo, si: 'OK', soloOk: true });
export const chiedi = (testo, valore = '', { si = 'OK', obbligatorio = true } = {}) => coda({ testo, valore, si, input: true, obbligatorio });

export function DialogoHost() {
  const [d, setD] = useState(null);
  const [v, setV] = useState('');
  const campo = useRef(null);
  useEffect(() => { apri = (x) => { setV(x.valore ?? ''); setD(x); }; return () => { apri = null; }; }, []);
  useEffect(() => { if (d?.input) setTimeout(() => campo.current?.select(), 30); }, [d]);
  if (!d) return null;
  const chiudi = (r) => { d.ok(r); setD(null); };
  const vuoto = d.input && d.obbligatorio && !v.trim();
  return createPortal(
    <div style={st.velo} onClick={e => e.stopPropagation()}>
      <form style={st.box} onClick={e => e.stopPropagation()} onSubmit={e => { e.preventDefault(); if (!vuoto) chiudi(d.input ? v : true); }}>
        <div style={st.testo}>{d.testo}</div>
        {d.input && <input ref={campo} style={st.input} value={v} onChange={e => setV(e.target.value)} />}
        <div style={st.bottoni}>
          {!d.soloOk && <button type="button" style={st.no} onClick={() => chiudi(d.input ? null : false)}>Annulla</button>}
          <button type="submit" autoFocus={!d.input} disabled={vuoto} style={{ ...st.si, ...(d.pericolo ? st.siRosso : {}), ...(vuoto ? { opacity: 0.5 } : {}) }}>{d.si}</button>
        </div>
      </form>
    </div>, document.body);
}

const st = {
  velo: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.35)', zIndex: 4000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '18vh 16px 0' },
  box: { background: 'var(--bg-card)', color: 'var(--text)', borderRadius: 18, padding: 20, width: '100%', maxWidth: 440, boxShadow: '0 20px 60px rgba(0,0,0,.25)', display: 'flex', flexDirection: 'column', gap: 12 },
  testo: { fontSize: 15, lineHeight: 1.45, whiteSpace: 'pre-line', fontWeight: 600 },
  input: { width: '100%', border: '1px solid var(--border2)', borderRadius: 12, padding: '10px 12px', fontSize: 15, color: 'var(--text)', background: 'var(--bg-card)', boxSizing: 'border-box' },
  bottoni: { display: 'flex', gap: 8, justifyContent: 'flex-end' },
  no: { border: '1px solid var(--border2)', background: 'var(--bg-card)', color: 'var(--text)', borderRadius: 999, padding: '9px 16px', fontWeight: 600, cursor: 'pointer', minHeight: 40 },
  si: { border: 'none', background: '#F4600C', color: '#fff', borderRadius: 999, padding: '9px 18px', fontWeight: 700, cursor: 'pointer', minHeight: 40 },
  siRosso: { background: '#C0392B' },
};
